var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:[
    'consent-full',
    { 'is-animation-start': _vm.isAnimationStart }
]},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"consent-full-flex flex flex-column flex-content-center bg-color-secondary"},[(_vm.icons)?_c('div',{class:[
                    'consent-full-icons',
                    'flex' ]},_vm._l((_vm.icons),function(icon){return _c('IconConsent',{key:icon,attrs:{"type":icon}})}),1):_vm._e(),_c('div',{staticClass:"consent-full-body"},[_c('span',{directives:[{name:"bastards",rawName:"v-bastards"}],staticClass:"fs-37 text-bold",domProps:{"textContent":_vm._s(_vm.bodyText)}})])])])])}
var staticRenderFns = []

export { render, staticRenderFns }